import { createSlice } from '@reduxjs/toolkit';
import { find } from 'lodash';
import { createSelector } from 'reselect';

const initialState = {
  subscriptions: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  loading: false,
  isSubscriptionCreated: false,
  isSubscriptionEdited: false,
  selectedSubscription: null,
  error: null,
  isSubscriptionCanceled: false,
};

const subscriptionSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    fetchSubscriptionsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSubscriptionsSuccess(state, action) {
      state.loading = false;
      state.subscriptions = action.payload.subscriptions;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalCount = action.payload.totalCount;
    },
    fetchSubscriptionsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchSubscriptionById(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSubscriptionByIdSuccess(state, action) {
      const subscription = action.payload;
      let found = find(state.subscriptions, { _id: subscription._id });
      if (!found) {
        state.subscriptions.push(subscription);
      }

      state.loading = false;
      state.selectedSubscription = action.payload;
    },
    fetchSubscriptionByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    createSubscriptionRequest(state) {
      state.loading = true;
      state.error = null;
      state.isSubscriptionCreated = false;
    },
    editSubscriptionRequest(state) {
      state.loading = true;
      state.error = null;
      state.isSubscriptionEdited = false;
    },
    createSubscriptionSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isSubscriptionCreated = true;
    },
    editSubscriptionFailure(state, action) {
      state.loading = false;
      state.isSubscriptionEdited = false;
      state.error = action.payload;
    },
    editSubscriptionSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isSubscriptionEdited = true;
    },
    createSubscriptionFailure(state, action) {
      state.loading = false;
      state.isSubscriptionCreated = false;
      state.error = action.payload;
    },
    cancelSubscriptionCreate(state) {
      state.loading = false;
      state.error = null;
      state.isSubscriptionCreated = false;
      state.isSubscriptionEdited = false;
    },
    cancelSubscriptionRequest(state) {
      state.loading = true;
      state.error = null;
      state.isSubscriptionCanceled = false;
    },
    cancelSubscriptionSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isSubscriptionCanceled = true;
    },
    cancelSubscriptionFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.isSubscriptionCanceled = false;
    },
    markSubscriptionCreated(state, action) {
      state.isSubscriptionCreated = action.payload;
    },
    markSubscriptionEdited(state, action) {
      state.isSubscriptionEdited = action.payload;
    },
    markSubscriptionCanceled(state, action) {
      state.isSubscriptionCanceled = action.payload;
    },
  },
});

export const {
  fetchSubscriptionsRequest,
  fetchSubscriptionsSuccess,
  fetchSubscriptionsFailure,
  fetchSubscriptionById,
  fetchSubscriptionByIdSuccess,
  fetchSubscriptionByIdFailure,
  createSubscriptionRequest,
  createSubscriptionSuccess,
  createSubscriptionFailure,
  editSubscriptionRequest,
  editSubscriptionFailure,
  editSubscriptionSuccess,
  markSubscriptionCreated,
  markSubscriptionEdited,
  cancelSubscriptionCreate,
  cancelSubscriptionRequest,
  cancelSubscriptionSuccess,
  cancelSubscriptionFailure,
  markSubscriptionCanceled,
} = subscriptionSlice.actions;

const subscriptionState = (state) => state.subscriptions;

export const selectSubscriptionById = (id) =>
  createSelector(
    [subscriptionState],
    (subscriptionState) => subscriptionState.subscriptions.find((subscription) => subscription._id === id) || {},
  );

export default subscriptionSlice.reducer;
